var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tags-container",style:({ left: _vm.left + 'px', top: _vm.top + 'px' })},[_c('canvas')])
}
var staticRenderFns = []

export { render, staticRenderFns }